import {PromotionBalanceEntryStatus, PromotionBalanceEntryQualifier} from '@gongxigames/framework/promotions';

export type PromotionBalanceEntry = {
    id: string;
    type: PromotionBalanceEntryQualifier;
    awarded: number;
    remained: number;
    bet: number;
    expirationTime?: string;
    completion?: boolean;
    collectedWin: number;
    status?: PromotionBalanceEntryStatus;
    rulesUrl?: string;
};